module.exports = __webpack_public_path__ + "static/media/Lani Rosenthal.8a7a3cb4.png";